export default (function (value) {
  return value;
});


// WEBPACK FOOTER //
// ../node_modules/redux-actions/es/utils/identity.js